import React from "react";
import { Page, StyleSheet, Text } from "@react-pdf/renderer";
import Footer from "./Footer";
import Title from "./common/Title";
import { config } from "./common/config";
import Table from "./common/Table";
import SectionHeader from "./common/SectionHeader";
import Row from "./common/Row";
import Subtasks from "./Subtasks";
import Chat from "./Chat";

const styles = StyleSheet.create({
  page: {
    padding: 50,
    paddingTop: 70,
    fontFamily: config.fontFamily,
    fontSize: config.normalFontSize,
  },
  tableSubtask: {
    width: "30%",
  },
  bottomBorder: {
    borderBottomColor: "#118052",
    borderBottomWidth: 2,
    marginBottom: 3,
    paddingTop: 5,
  },
});

const getStatus = (status) =>
  status === "doing"
    ? "Em dia"
    : status === "late"
      ? "Atrasado"
      : status === "done"
        ? "Concluído"
        : status === "doneLate"
          ? "Concluído com atraso"
          : "Pendente";

const getStyleStatus = (status) => {
  const baseStyle = {
    fontWeight: 600,
  };
  const styles = {
    doing: {
      // backgroundColor: "#f8e47c",
      // color: "#786a23",
      color: "#786a26",
    },
    late: {
      // backgroundColor: "#eb5757",
      // color: "#fff",
      color: "#eb5757",
    },
    done: {
      // backgroundColor: "#118052",
      // color: "#fff",
      color: "#118052",
    },
    doneLate: {
      // backgroundColor: "#9f2d1d",
      // color: "#fff",
      color: "#9f2d1d",
    },
    pending: {
      // backgroundColor: "#eff1f5",
      color: "#7e858f",
    },
  };

  return { ...baseStyle, ...styles[status] };
};

function formatarData(dataString) {
  const data = new Date(dataString);
  const dia = data.getDate().toString().padStart(2, "0");
  const mes = (data.getMonth() + 1).toString().padStart(2, "0"); // Os meses começam do 0
  const ano = data.getFullYear();
  const horas = data.getHours().toString().padStart(2, "0");
  const minutos = data.getMinutes().toString().padStart(2, "0");

  return `${dia}/${mes}/${ano} ${horas}:${minutos}`;
}

function accumSubtask(subtasks) {
  return subtasks.reduce(
    (acc, current) => (current.checked ? (acc = acc + 1) : acc),
    0,
  );
}
const TaskRelatory = ({ relatory }) => {
  return (
    <Page size="A4" style={styles.page}>
      {/* <Header relatory={relatory} /> */}
      <Title>Tarefas</Title>

      {relatory.tasks.map((task, i) => (
        <React.Fragment key={i}>
          <Row>
            <SectionHeader>{task.label}</SectionHeader>
          </Row>
          <Table>
            <Table.Header>
              <Table.HeaderCell>Estado</Table.HeaderCell>
              <Table.HeaderCell>Início</Table.HeaderCell>
              <Table.HeaderCell>Fim</Table.HeaderCell>
              <Table.HeaderCell>Tempo Max.</Table.HeaderCell>
              <Table.HeaderCell>Usuário</Table.HeaderCell>
            </Table.Header>
            <Table.Body>
              <Table.Row>
                <Table.Cell>
                  <Text
                    style={getStyleStatus(
                      task.currentStatus?.currentStatus
                        ? task.currentStatus.currentStatus
                        : task.status,
                    )}
                  >
                    {getStatus(task?.currentStatus?.currentStatus)}
                  </Text>
                </Table.Cell>
                <Table.Cell>
                  {task?.startedAt ? formatarData(task.startedAt) : "--"}
                </Table.Cell>
                <Table.Cell>
                  {task?.finishedAt ? formatarData(task.finishedAt) : "--"}
                </Table.Cell>
                <Table.Cell>
                  {(task.duration / 24).toFixed(1)} dia(s)
                </Table.Cell>
                <Table.Cell>
                  {task.acc
                    ? `${task.acc.userData.username.split(" ")[0]} ${
                        task.acc.userData.username.split(" ")[1]?.charAt(0)
                          ? task.acc.userData.username
                              .split(" ")[1]
                              ?.charAt(0) + "."
                          : ""
                      }`
                    : "--"}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
          <Row
            style={{
              justifyContent: "flex-end",
              fontWeight: "bold",
              marginTop: 5,
            }}
          >
            <Text style={{ marginRight: 10 }}>
              Subtarefas Totais: {task.subtasks.length}
            </Text>
            <Text style={{ marginRight: 10 }}>
              Subtarefas Resolvidas: {accumSubtask(task.subtasks)}
            </Text>
          </Row>
          <Subtasks label={task.label} subtasks={task.subtasks} />

          {task?.chat && task.chat?.length && (
            <React.Fragment>
              <Row>
                <SectionHeader style={styles.bottomBorder}>
                  Comentários de {task.label}
                </SectionHeader>
              </Row>
              {<Chat chat={task.chat} />}
            </React.Fragment>
          )}
        </React.Fragment>
      ))}
      <Footer />
    </Page>
  );
};
export default TaskRelatory;
